import { call, put, takeLeading } from 'redux-saga/effects';
import adminActions from './actions';
import errorActions from '../error/actions';
import dxApi from 'services/dxApi';
import authUtils from 'utils/auth';

const {
  Types: {
    ADMIN_LOGIN_REQUEST,
    ADMIN_LOGOUT_REQUEST,
    ADMIN_ADD_GOALS_REQUEST,
    ADMIN_GET_GOALS_REQUEST,
    ADMIN_ADD_UNITS_REQUEST,
    ADMIN_GET_UNITS_REQUEST,
    ADMIN_RESET_PASSWORD_REQUEST,
    ADMIN_GYMPASS_HISTORY_REQUEST,
  },
  Creators: {
    adminLoginFailure,
    adminLoginSuccess,
    adminLogoutSuccess,
    adminLogoutFailure,
    adminAddGoalsFailure,
    adminAddGoalsSuccess,
    adminGetGoalsFailure,
    adminGetGoalsSuccess,
    adminAddUnitsFailure,
    adminAddUnitsSuccess,
    adminGetUnitsFailure,
    adminGetUnitsSuccess,
    adminResetPasswordFailure,
    adminResetPasswordSuccess,
    adminGympassHistoryFailure,
    adminGympassHistorySuccess,
  },
} = adminActions;

const {
  Creators: { setError },
} = errorActions;

function* adminPanelLogin({ payload }) {
  try {
    const { email, password } = payload;

    const { data } = yield call(dxApi.post, '/admin/admin-login', {
      email,
      password,
    });
    if (!data.success) {
      yield put(adminLoginFailure(data.message));
      yield put(setError(data.message));
    } else {
      const loginData = data.data;
      authUtils.setAdminToken(loginData.accessToken);
      dxApi.setAuthTokenToHeader(loginData.accessToken);
      yield put(adminLoginSuccess(data));
    }
  } catch (err) {
    console.log('admin login err: ', err);
    yield put(adminLoginFailure(err));
    yield put(setError('Login error.'));
  }
}

function* adminLogout() {
  try {
    authUtils.removeAdminToken();
    yield put(adminLogoutSuccess());
  } catch (err) {
    yield put(adminLogoutFailure(err));
  }
}

function* adminAddGoals({ payload }) {
  try {
    const { data } = yield call(dxApi.post, '/admin/projected-unit-goals', payload);
    if (!data.success) {
      yield put(adminAddGoalsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(adminAddGoalsSuccess(true));
    }
  } catch (err) {
    yield put(adminAddGoalsFailure(err));
    yield put(setError('Adding goals error.'));
  }
}

function* getAdminGoals({ locationId }) {
  try {
    const { data } = yield call(
      dxApi.get,
      `/admin/get-projected-unitgoals-history?locationId=${locationId}`
    );
    if (!data.success) {
      yield put(adminGetGoalsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(adminGetGoalsSuccess(data));
    }
  } catch (err) {
    yield put(adminGetGoalsFailure(err));
    yield put(setError('Getting goals error.'));
  }
}

function* addGympassUnits({ payload }) {
  try {
    const { data } = yield call(dxApi.post, '/admin/gympass-unit-details', payload);
    if (!data.success) {
      yield put(adminAddUnitsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(adminAddUnitsSuccess(true));
    }
  } catch (err) {
    yield put(adminAddUnitsFailure(err));
    yield put(setError('Adding units error.'));
  }
}

function* getGympassUnits({ locationId }) {
  try {
    const { data } = yield call(
      dxApi.get,
      `/admin/get-gympass-unit-history?locationId=${locationId}`
    );
    if (!data.success) {
      yield put(adminGetUnitsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(adminGetUnitsSuccess(data));
    }
  } catch (err) {
    yield put(adminGetUnitsFailure(err));
    yield put(setError('Getting units error.'));
  }
}

function* adminResetPassword({ payload }) {
  try {
    const { data } = yield call(dxApi.post, '/admin/admin-reset-password', payload);
    if (!data.success) {
      yield put(adminResetPasswordFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(adminResetPasswordSuccess(true));
      yield put(setError('Password updated successfully.'));
    }
  } catch (err) {
    console.log('admin reset password err: ', err);
    yield put(adminResetPasswordFailure(err));
    yield put(setError('Admin reset password error.'));
  }
}

function* adminGympassHistory({ payload }) {
  try {
    const { data } = yield call(dxApi.post, '/admin/get-gympass-history', payload);
    if (!data.success) {
      yield put(adminGympassHistoryFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(adminGympassHistorySuccess(data.data));
    }
  } catch (err) {
    yield put(adminGympassHistoryFailure(err));
    yield put(setError('Getting gympass history error.'));
  }
}

export function* adminPanelSaga() {
  yield takeLeading(ADMIN_LOGIN_REQUEST, adminPanelLogin);
  yield takeLeading(ADMIN_LOGOUT_REQUEST, adminLogout);
  yield takeLeading(ADMIN_ADD_GOALS_REQUEST, adminAddGoals);
  yield takeLeading(ADMIN_GET_GOALS_REQUEST, getAdminGoals);
  yield takeLeading(ADMIN_ADD_UNITS_REQUEST, addGympassUnits);
  yield takeLeading(ADMIN_GET_UNITS_REQUEST, getGympassUnits);
  yield takeLeading(ADMIN_RESET_PASSWORD_REQUEST, adminResetPassword);
  yield takeLeading(ADMIN_GYMPASS_HISTORY_REQUEST, adminGympassHistory);
}
